import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'

import { AsyncThunkConfig } from '@/store/actions'
import { OrganizationDemo } from '@/store/demo'

export const demo = {
  app: {
    initDemo: createAsyncThunk<{ organizations: OrganizationDemo[] }, void, AsyncThunkConfig>(
      'INIT_DEMO',
      async (_, { extra, fulfillWithValue, rejectWithValue }) => {
        const { api } = extra
        const res = await api.demo.get()
        if (hasError(res)) return rejectWithValue(handleError(res))
        return fulfillWithValue(res)
      },
    ),

    resetDemo: createAsyncThunk<{ success: boolean }, { organizationId: string }, AsyncThunkConfig>(
      'RESET_DEMO',
      async (p, { extra, fulfillWithValue, rejectWithValue, dispatch }) => {
        const { api } = extra
        const res = await api.demo.reset(p)
        if (hasError(res)) return rejectWithValue(handleError(res))

        // Dispatch another action to refresh the demo organizations
        await dispatch(demo.app.initDemo())
        return fulfillWithValue(res)
      },
    ),
  },
}
